import { useUser } from './userContext';
import { pageAccessConfig, UserRole } from '../roleConfig';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export const usePageAccess = () => {
  const user = useUser();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname;
    const allowedRoles = pageAccessConfig[currentPath] || [];

    // Check if user has any of the allowed roles
    const hasAccess = user?.roles.some(role => allowedRoles.includes(role));

    if (!hasAccess) {
      navigate('/');
    }
  }, [user, location, navigate]);

  return user?.roles || [UserRole.SBU];
};